module.exports = __webpack_public_path__ + "static/media/takeshi.eda36aad.webp";